// extracted by css-extract-rspack-plugin
var _1 = "item-PpwpQq";
var _2 = "tack-AYyViA";
var _3 = "tack-green-NeOgVF";
var _4 = "tack-grey-iroksp";
var _5 = "tack-orange-TwlFmM";
var _6 = "tack-org-i5F_Ag";
var _7 = "tack-red-ikUlN4";
var _8 = "tack-seal-jnwuA5";
var _9 = "tack-square-border-SgArOk";
var _a = "tack-text-ftTmdS";
var _b = "tack-green-NeOgVF";
var _c = "tack-grey-iroksp";
var _d = "tack-orange-TwlFmM";
var _e = "tack-org-i5F_Ag";
var _f = "tack-red-ikUlN4";
var _10 = "tack-seal-jnwuA5";
var _11 = "tack-square-border-SgArOk";
var _12 = "tack-text-ftTmdS";
export { _1 as "item", _2 as "tack", _3 as "tack-green", _4 as "tack-grey", _5 as "tack-orange", _6 as "tack-org", _7 as "tack-red", _8 as "tack-seal", _9 as "tack-square-border", _a as "tack-text", _b as "tackGreen", _c as "tackGrey", _d as "tackOrange", _e as "tackOrg", _f as "tackRed", _10 as "tackSeal", _11 as "tackSquareBorder", _12 as "tackText" }
